import { ButtonLink, CenterContainer, Container, H2, Show } from './landing.styles.js'
import mobileBanner from './review-mobile.png'
import { Banner, Head, MobileBanner, Review, Root, Title } from './reviews.styles.js'

import { logEvent } from '../../utils/firebase.js'
import stars from './stars.svg'

const Reviews = () => {
  return (
    <Root>
      <CenterContainer>
        <Show on="desktop">
          <H2>Why Users Love the DecorMatters Design App</H2>
        </Show>
        <Show on="mobile">
          <H2>Why Users Love the DecorMatters Design App</H2>
        </Show>
      </CenterContainer>
      <Container>
        <div>
          <a
            target="_blank"
            href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467"
            onClick={() => {
              logEvent('download_ios_app_click', {})
            }}
          >
            <MobileBanner src={mobileBanner} />
          </a>
          <Review>
            <Head>
              <Title>
                My favorite interior design app, it’s like therapy!
                <img src={stars} />
              </Title>
              <span>-coola</span>
            </Head>
            <span>I’ve been using DecorMatters since 2021. It’s the best interior design app out there. I love being creative, seeing others’ designs, and being part of such a positive, inspiring community.</span>
          </Review>
          <Review>
            <Head>
              <Title>
                AR made designing my room so much easier
                <img src={stars} />
              </Title>
              <span>-Itachixxxxx</span>
            </Head>
            <span>I wasn’t sure if a new sofa would work in my space. DecorMatters let me preview it in my real room using augmented reality. It saved me time, money, and stress. Truly the best room design app I’ve tried.</span>
          </Review>
          <Review>
            <Head>
              <Title>
                A fun decorating game that feels real
                <img src={stars} />
              </Title>
              <span>-IIwDr.Remulac</span>
            </Head>
            <span>I’ve been playing for over a year. The design challenges are fun and the furniture looks just like the real thing. I love that you can shop real products and get inspired by other users’ designs too.</span>
          </Review>
        </div>
        <Banner>
          <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
            Start Designing Now
          </ButtonLink>
        </Banner>
      </Container>
    </Root>
  )
}

export default Reviews
